import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaStore, FaQrcode } from 'react-icons/fa';

const BranchConfirmModal = ({ isOpen, onProceed, branchName, tableName }) => {
  return (
    <Modal 
      show={isOpen} 
      backdrop="static" 
      keyboard={false} 
      centered 
      dialogClassName="branch-confirm-dialog mx-auto" 
      contentClassName="border-0 shadow-lg rounded-xlg overflow-hidden branch-confirm-content"
      className="branch-confirm-modal"
      backdropClassName="branch-confirm-backdrop"
      style={{ zIndex: 1070 }}
    >
      <div className="modal-body py-4 px-5 text-center">
        <div 
          className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 branch-icon-wrap" 
          style={{ width: '60px', height: '60px', backgroundColor: '#f1f5f9' }}
        >
          <FaStore size={28} style={{ color: '#0f172a' }} />
        </div>

        <h4 className="mt-2 font-weight-bold text-dark mb-2" style={{ fontSize: '20px' }}>
          {branchName || "Restaurant Branch"}
        </h4>

        {tableName && (
          <div className="mb-3 mt-1">
            <span 
              className="badge px-3 py-1 font-weight-bold" 
              style={{ backgroundColor: '#e2e8f0', color: '#334155', borderRadius: '12px', fontSize: '14px' }}
            >
              Table: {tableName}
            </span>
          </div>
        )}

        <p className="text-secondary mt-3 mb-4" style={{ fontSize: '15.5px', lineHeight: '1.5' }}>
          Are you sure you want to place an order at this branch?
        </p>

        <div className="d-flex flex-column" style={{ gap: '12px' }}>
          <button 
            type="button"
            className="btn text-white w-100 py-2 rounded-pill shadow-sm font-weight-bold branch-proceed-btn"
            style={{ backgroundColor: '#0f172a', fontSize: '16px' }}
            onClick={onProceed}
          >
            Proceed
          </button>

          <div className="pt-1">
            <p className="text-muted mb-0" style={{ fontSize: '14.3px', lineHeight: '1.5' }}>
              <FaQrcode className="mr-1 text-secondary" style={{ verticalAlign: '-1px' }} size={13} />
              If this is not your branch or table, please scan your table's QR code again.
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(BranchConfirmModal);
